export const borders = {
  none: 'none',
  unset: 'unset',
  extraSmall: 8,
  small: 16,
  medium: 24,
  large: 32,
  border1: 1,
  border2: 2,
  border4: 4,
  border15: 15,
  border16: 16,
  border3px: '3px',
  borderRound: '50%',
  borderDotted: 'dotted',
  borderLine2pxDotted: '2px dotted',
  borderLine1p5dashed: '1.5px dashed',
  borderSolid: 'solid',
  borderLine: '1px solid',
  borderLine1p5px: '1.5px solid',
  borderLine1p6px: '1.6px solid',
  borderLine2px: '2px solid',
  borderLine3px: '3px solid',
  borderLine4px: '4px solid',
  borderLine5px: '5px solid',
  borderLine6px: '6px solid',
  borderLine8px: '8px solid',
  borderSolidXSmall: '2px solid',
  borderSolidSmall: '3px solid',
  borderSolidMedium: '4px solid',
  borderSolidLarge: '8px solid',
  borderSkillInsightsCard: '10px solid ',
  borderSolidTransparent: 'solid transparent',
  borderLine1Gray: '1px solid #C4CDD5',
  borderLine1Rgba012: '1px solid rgba(0, 0, 0, 0.12)',
  width2px: '2px',
  width5px: '5px',
  empty: 0,
  radius0p5: 0.5,
  radius1: 1,
  radius1rem: '0.0625rem',
  radius2: 2,
  radius2rem: '0.125rem',
  radius3: 3,
  radius4: 4,
  radius4rem: '0.25rem',
  radius5: 5,
  radius5rem: '0.3125rem',
  radius6: 6,
  radius6rem: '0.375rem',
  radius8: 8,
  radius8rem: '0.5rem',
  radius10: 10,
  radius10rem: '0.625rem',
  radius12: 12,
  radius16: 16,
  radius16rem: '1rem',
  radius24: 24,
  radius50: 50,
  radius50rem: '3.125rem',
  radius100: 100,
  radius100rem: '6.25rem',
  customRadius3: 3,
  skillCardBoxShadows: '0 8px 16px',
  mainCardBoxShadowFirst: '0px 0px 2px rgba(145, 158, 171, 0.24)',
  mainCardBoxShadowSecond: '0px 16px 32px -4px rgba(145, 158, 171, 0.24)',
  textWrapperEmptyCard: '0 0 16px 16px',
  boxShadow: '0px 8px 16px rgba(145, 158, 171, 0.24)',
  boxShadowButtonAddRemoveSkill: '0px 8px 16px',
  boxShadowCard: '0 1px 3px rgba(0, 0, 0, 0.1)',
  boxShadowElevated: '0 4px 20px rgba(0, 0, 0, 0.08)',
  radiusButtonsLeft: '4px 0 0 4px',
  radiusButtonsRight: '0 4px 4px 0',
  borderLineDashed: '1px dashed',
  backDashboardBoxShadow: '0 8px 16px 0',
  boxShadowCardsSkillInsights: '0 4px 8px',
  buttonFloatingPathways: '0 4px 4px',
  pathwaysBannerSkillSet: '0 2px 4px',
  carrouselButtonBoxShadowFirst: '0 24px 48px',
  carrouselButtonBoxShadowSecond: '0 0 4px',
  BannerSkillCard: '0 4px 8px',
  filterSavedCoursesFirst: '0 2px 4px -1px rgba(0, 0, 0, 0.2)',
  filterSavedCoursesSecond: '0 4px 5px 0 rgba(0, 0, 0, 0.14)',
  jobTitleSalaryFirst: '0 1px 3px 1px #00000026',
  jobTitleSalarySecond: '0 1px 2px 0 #0000004D',
  roiBoxShadowFirst: '0px 8px 16px 0px rgba(145, 158, 171, 0.24)',
  roiBoxShadowSecond: '0px 8px 16px 0px rgba(145, 158, 171, 0.35)',
  occupationComparisonMobileBoxShadowFirst: '0px 0px 4px rgba(145, 158, 171, 0.24)',
  occupationComparisonMobileBoxShadowSecond: '0px 24px 48px rgba(145, 158, 171, 0.24)',
};
